import HeaderComponent from "../../global-components/header";
import ApresentacaoComponent from "./components/Apresentacao";
import SliderComponent from "./components/Slider";
import DiferencasComponent from "./components/Diferenças";
import DuvidasComponent from "./components/Duvidas";
import GarantiaComponent from "./components/Garantia";
import InvestmentComponent from "./components/Investment";
import PassoPassoComponent from "./components/PassoPasso";
import PerguntasComponent from "./components/Perguntas";
import SolucoesComponent from "./components/Solucoes";
import Confianca from "./components/Confianca";
import AprendizadoComponent from "./components/Aprendizado";
import TrilhaComponent from "./components/Trilha";
import PrecosComponent from "./components/Precos";
import CursoComponent from "./components/Curso";
import BannerComponent from "./components/Banner";
import FaqComponent from "./components/FAQ";
import FooterComponent from "./components/Footer";
import SliderGoogleComponent from "./components/SliderGoogle";

function Homepage() {
  
  return (
    <div>
      <HeaderComponent />
      <ApresentacaoComponent />
      <PerguntasComponent />
      <SolucoesComponent />
      <Confianca />
      <DuvidasComponent />
      <InvestmentComponent />
      <DiferencasComponent />
      <GarantiaComponent />
      <PassoPassoComponent />
      <SliderComponent />
      <SliderGoogleComponent />
      <AprendizadoComponent />
      <TrilhaComponent />
      <PrecosComponent />
      <CursoComponent />
      <BannerComponent />
      <FaqComponent />
      <FooterComponent />
    </div>
  );
}

export default Homepage;
